module.exports = __webpack_public_path__ + "static/media/Human_ZG4874_1440.3a6513c1.jpeg";